export enum BundlePrebookResponseType {
  HOTEL = 'Hotel',
  TOUR = 'Tour',
  FLIGHT = 'Flight',
  TRANSFER = 'Transfer',
}
